// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"be78541f","703":"9982154b","787":"064c981d"}[chunkId] + ".chunk.js";
};